import { Switch } from "antd";
import { Button1, Button2, Checkbox } from "../index";
import { BellIcon } from "../svg-organizer/SvgOrganizer";
import Table from "../table/Table";
import { useNavigate } from "react-router-dom";
import { useGroupExpenses, useGroups } from "../../data/live";

const money = (amount, currency) =>
  `${Number(amount || 0).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })} ${currency || ""}`.trim();

const GroupBalanceDetails = () => {
  const navigate = useNavigate();
  const { items: groups, loading: groupsLoading } = useGroups();
  const group = groups[0];
  const { items: expenses, loading: expensesLoading } = useGroupExpenses(group?.id);
  const currency = expenses[0]?.currency || group?.totalCurrency || "";
  const balanceRows = (group?.memberDetails || []).map((member) => {
    const owed = expenses.reduce((sum, expense) => {
      const split = (expense.splits || []).find((item) => item.userId === member.userId);
      return sum + Number(split?.amountOwed || 0);
    }, 0);
    return {
      accountInfo: {
        icon: "",
        name: member.name,
        amount: money(owed, currency),
      },
      category: group.category || "Not set",
      tags: Array.isArray(group.tags) ? group.tags : [],
      description: (
        <span className="fs14px" style={{ color: "#7D7D7D" }}>
          {member.name} has {money(owed, currency)} assigned across group expenses.
        </span>
      ),
      you: false,
    };
  });

  const groupBalanceTableHeaders = [
    <Checkbox />,
    "Account",
    "Category",
    "Tags",
    "Description",
    "Action",
  ];

  return (
    <>
      <div className="col-12">
        <div className="d-flex flex-column gap-3 mt-3 border rounded-3">
          <div className="d-flex justify-content-md-between justify-content-center gap-md-0 gap-2 align-items-center px-4 p-3 border-bottom flex-wrap">
            <span className="fs-5 fw-semibold">Group Balance</span>

            <div className="d-flex gap-3 align-items-center flex-wrap justify-content-center">
              <div className="d-flex gap-2 align-items-center">
                <span className="fs12px" style={{ color: "#7D7D7D" }}>
                  Simplify debts
                </span>
                <Switch defaultChecked={true} />
              </div>

              <Button2
                buttonName={"Send Reminder"}
                icon={<BellIcon />}
                className={"btn-outline-success"}
                divClassName={"gap-2"}
                onClick={() => navigate("/reminder")}
              />
              <Button1 buttonName={"Request Payment"} className={"btn-dark"} disabled />
            </div>
          </div>

          <div className="px-4 p-3">
            {groupsLoading || expensesLoading ? (
              <div className="p-5 text-center text-muted">Loading balances...</div>
            ) : !group ? (
              <div className="p-5 text-center text-muted">No group found.</div>
            ) : balanceRows.length ? (
              <Table
                tableBody={balanceRows}
                tableHeaders={groupBalanceTableHeaders}
                GroupBalanceTable={true}
                className={"w-100"}
                keyNumber1={4}
                condition1={"col-3"}
                condition2={""}
              />
            ) : (
              <div className="p-5 text-center text-muted">No group balances found.</div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default GroupBalanceDetails;
